import React from 'react';
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import Icon from "@mui/material/Icon";
import Alert from "@mui/material/Alert";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

function EditLeaseForm(props) {
    const {
        loading,
        loadingButton,
        errorMessage,
        errors,
        onHandleSubmit,
    } = props;

    return (
        <MDBox pt={0} pb={3}>
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <Card>
                        <Grid container spacing={2}>
                            {/* Display validation errors */}
                            {errors && errors.map((err, index) => (
                                <Grid item xs={12} key={index}>
                                    <FormHelperText error>{err}</FormHelperText>
                                </Grid>
                            ))}
                        </Grid>
                    </Card>
                </Grid>
            </Grid>
        </MDBox>
    )
}

export default EditLeaseForm;
